import {Injectable,} from '@angular/core';

/**
 * 開いているWindowをスタックする。
 * ログアウト時にはここにスタックされているすべてのWindowを閉じる。
 */
@Injectable({
  providedIn: 'root',
})
export class WindowStack {
  private windowStack: Map<string, Window> = new Map<string, Window>();

  /**
   * [一般開発者利用不可]
   * WindowスタックにWindowオブジェクトを追加する
   * @param key キー
   * @param windowオブジェクト
   */
  add(key: string, window: Window): void {
    this.windowStack.set(key, window);
  }

  /**
   * [一般開発者利用不可]
   * Windowスタックを取得する
   */
  get(): Map<string, Window> {
    return this.windowStack;
  }
}
